import { Injectable } from '@angular/core';
import { ActionMenuContext } from '../models/nxp-action-menu-context.model';

@Injectable()
export class MockActionMenuService {
    getActionMenuList(context: ActionMenuContext): any[] { return []; }
    handleContextClick(type: string, value: any): any {}
    handleActionMenuClick(type: string, value: any, target: string): any {}
}
